import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, filter) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/RegistrationTypes/List`, method: 'POST', body: filter, token: token })
}
